// @ts-nocheck
/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.3
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

const reportsDoughnutChartData = {
  labels: ["Living Room", "Kitchen", "Attic", "Garage", "Basement"],
  datasets: {
    label: "Consumption",
    backgroundColors: ["primary", "secondary", "info", "success", "warning"],
    data: [15, 20, 13, 32, 20],
  },
};

export default reportsDoughnutChartData;
